import { Component, OnInit, OnDestroy, Inject, Input, Output, EventEmitter } from '@angular/core';
import { ClientInterface } from '../../interfaces/client-data';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ImpersonationService } from '../../services/impersonation.service';
//import { FiltersService } from '../../services/filters.service';
import { CurrentUserStateService } from '../../services/current-user-state.service';
import { DisplayOptionsService } from '../../services/display-options.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientsService } from 'app/modules/shared/services/clients.service';

@Component({
    selector: 'change-client-dialog',
    templateUrl: './change-client-dialog.component.html',
    styleUrls: ['./change-client-dialog.component.scss'],
})
export class ChangeClientDialogComponent implements OnInit, OnDestroy {
    data: any[] = [];
    visibleData: any[] = [];
    selectedClient: any = null;
    savingClientChange = false;

    statusFilter = true;
    statusFilters = [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false },
    ];

    subscriptionFilter = 0;
    subscriptionFilters = [{ label: 'All', value: 0 }];

    @Output() closed = new EventEmitter<boolean>();
    constructor(
        public _router: Router,
        public _location: Location,
        private impersonationService: ImpersonationService,
        private _displayOptionsService: DisplayOptionsService,
        private currentUserStateService: CurrentUserStateService,
        private _clientService: ClientsService
    ) {}

    ngOnDestroy() {}

    ngOnInit() {
        if (!this.isLBASuperAdmin) {
            this.closeDialog();
        }

        this._clientService.getClientsData().subscribe({
            next: (data) => {
                this.data = data;

                // Move Big Home to the top of the list
                let bigHome = this.data.find((x) => x.clientShortName === 'Big Home');
                if (bigHome) {
                    this.data = this.data.filter((x) => x.clientShortName !== 'Big Home');
                    this.data.unshift(bigHome);
                }

                this.visibleData = [...data];

                // Get distinct list of enrollments
                const uniqueEnrollmentData = this.data.filter(
                    (value, index, self) =>
                        index ===
                        self.findIndex(
                            (t) => t.clientSubscriptionTypeKey === value.clientSubscriptionTypeKey
                        )
                );

                // Set the enrollments filter
                uniqueEnrollmentData
                    .map((x) => {
                        return {
                            label: x.subscriptionName,
                            value: x.clientSubscriptionTypeKey,
                        };
                    })
                    .sort((a, b) => {
                        return a.label.localeCompare(b.label);
                    })
                    .forEach((x) => {
                        this.subscriptionFilters.push({
                            label: x.label,
                            value: x.value,
                        });
                    });

                this.updateFilters();
            },
        });
    }

    updateFilters() {
        this.visibleData = [...this.data];

        if (this.subscriptionFilter !== 0) {
            this.visibleData = this.visibleData.filter(
                (x) => x.clientSubscriptionTypeKey === this.subscriptionFilter
            );
        }

        this.visibleData = this.visibleData.filter((x) => this.statusFilter === x.active);
    }

    isLBASuperAdmin() {
        return (
            this.currentUserStateService.isLBASuperUser() ||
            this.currentUserStateService.isPlatformUser()
        );
    }

    setClient() {
        if (this.selectedClient == null) return;

        this.savingClientChange = true;

        this.impersonationService.startImpersonatingClient(this.selectedClient.clientShortName);
        localStorage.removeItem('mainFilters');
        localStorage.removeItem('displayOptionsStorage');

        this._displayOptionsService.getAllUniqueDisplayOptionItems().subscribe({
            next: (results) => {
                this._displayOptionsService.updateCurrentDynamicDisplayOptions(results);
                const pageName = location.pathname.slice(1);
                this.savingClientChange = false;
                this.closeDialog();

                this._router.navigate(['']).then(() => {
                    this._router.navigate([pageName]);
                });
            },
        });
    }

    closeDialog() {
        this.closed.emit(true);
    }
}
